import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import localizacaoImg from '../../images/img-localizacao.jpg'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    websitesContainer: {
        backgroundColor: "white",
        display: "flex",
        flexFlow: "column-reverse",
        margin: "auto",
        maxWidth: "100%",
        textAlign: "center",
        paddingLeft: "8vw !important",
        paddingRight: "8vw !important",
        [theme.breakpoints.up('md')]: {
            flexFlow: "inherit",
            marginTop: "15px",
            maxWidth: "100%"
        }
    },
    websitesLeftDiv: {
        maxWidth: "100%",
        margin: "auto",
        paddingLeft: "4vw !important",
        paddingRight: "4vw !important",
        [theme.breakpoints.up('md')]: {
            textAlign: "left",
            paddingTop: "8vw!important",
            marginTop: "0px",
            backgroundColor: "transparent"
        }
    },
    websitesRightDiv: {
        maxWidth: "100%",
    },

    websitesText: {
        color: "#353535",
        fontFamily: "Oswald, sans-serif",
        fontWeight: 500,
        fontSize: "32px",
        textTransform: "uppercase",
        maxWidth: "450px",
        lineHeight: "35px",
        margin: "auto",
        [theme.breakpoints.up('md')]: {
            marginLeft: "0px"
        }
    },
    websitesTextArea: {
        fontFamily: "Poppins, sans-serif",
        fontSize: "18px",
        color: "#606060",
        lineHeight: "35px"
    },
    websitesImage: {
        objectFit: "cover",
        height: "auto",
        width: "80%",
        [theme.breakpoints.up('md')]: {
            width: "100%",
        }
    },
    itemContato: {
        fontSize: "14px", 
        color: "#353535", 
        minHeight: "50px",
        backgroundColor: "#FFCE2D", 
        borderRadius: "0px",
        margin: "auto",
        paddingLeft: "20px",
        paddingRight: "20px",
        marginTop: "20px",
        '&:hover': {
          backgroundColor: "#F9D56E",
        },
      },
      websitesContainerMore: {
        backgroundColor: "white",
        marginTop: "40px",
        marginBottom: "40px",
        maxWidth: "100%",
        textAlign: "center",
        display: "block",
        [theme.breakpoints.up('md')]: {
            marginTop: "15px",
        }
    },
}));

export default function Details(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div style={{textAlign: "center"}}>
        <Grid id="details" container spacing={3} className={classes.websitesContainer}>
            <Grid id="detailsDiv" item xs={6} className={classes.websitesLeftDiv}>
                <Typography variant="h1" >
                    <Fade left>
                        <p className={classes.websitesText}>Excelente localização em Caraguatatuba</p>
                    </Fade>
                </Typography>
                <Typography variant="h5" >
                    <Fade>
                        <p className={classes.websitesTextArea}>
                            No bairro Jardim Britânia, em Caraguatatuba, a UMA quadra da praia, próximo aos principais pontos turísticos e comerciais da cidade, como o Shopping Serramar, Hospital Regional, Praias do Indaiá e Martim de Sá, além de fácil acesso para as melhores praias do litoral norte.
                        </p>
                    </Fade>
                </Typography>
            </Grid>
            <Grid id="websitesRight" item xs={6} className={classes.websitesRightDiv}>
                <img src={localizacaoImg} alt="websites" className={classes.websitesImage} />
            </Grid>
        </Grid>
        {props.more === "true" &&
        <Grid id="detailsMore" container  className={classes.websitesContainerMore}>
            <Link to="/edificio-sansiro" style={{textDecoration: "none"}}>
                <Button
                    edge="end"
                    aria-label="account of current user"
                    aria-haspopup="true"
                    color="inherit"
                    className={classes.itemContato}
                >
                    Saiba mais
                </Button>
            </Link>
        </Grid>
        }
        </div>
    )
}